import React, { Component } from 'react';
import { connect } from 'react-redux';
import { do_action } from '../../actions';
import ModalUpdatePriceItems from '../Modal/ModalUpdatePriceItems'
import Pagination from '../Common/Pagination'
import {convertPrice, convertPriceNumber} from '../../utils/convert'
import Spinner from 'react-spinkit'

class ListItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allItems: [],
            itemVendor: [],
            page: 1,
            number_page: 1,
            total: 0,
            limit: 10,
            itemUpdate: '',
            nb_click: 1,
            isLoading: false,
            itemIdx: 0
        }
    }

    componentWillMount() {
        let {vendor} = this.props;
        if (vendor._id) {
            this.getItemPage(vendor, 1);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.vendor && (!this.props.vendor || (this.props.vendor && nextProps.vendor._id != this.props.vendor._id))) {
            this.getItemPage(nextProps.vendor, 1)
        }
    }

    clickPage = (page) => {
        this.getItemPage(this.props.vendor, page)
    }

    getItemPage(vendor, page) {
        this.setState({isLoading: true})

        let vendor_id = vendor._id
        let type = vendor.type
        let group_id = vendor.group_id || ''
        let {limit} = this.state
        do_action('get_items_vendor_pagination', { vendor: vendor_id, group_id, type, page, limit })
            .then(data => {
                this.setState({isLoading: false})
                if (data.signal) {
                    let {allItems, itemVendor, total, number_page} = data.data;
                    let dataItemVendor = {};
                    itemVendor.map(it => {
                        dataItemVendor[it.item_id] = it.price;
                    });

                    this.setState({
                        allItems,
                        itemVendor: dataItemVendor,
                        number_page,
                        total,
                        page
                    });
                }
            })
            .catch(err => {
                this.setState({isLoading: false})
                console.log(err)
            })
    }

    nextItem() {
        let {itemIdx, allItems} = this.state
        let items = allItems[itemIdx]
        if (!items) return

        let numberIt = allItems.length

        if (itemIdx + 1 < numberIt)
            this.setState({
                itemUpdate: allItems[itemIdx + 1],
                itemIdx: itemIdx + 1
            })

        else 
            this.setState({
                itemUpdate: allItems[0],
                itemIdx: 0
            })
    }

    updatePrice(item, price) {
        let {itemVendor} = this.state;
        itemVendor[item] = price;
        this.setState({
            itemVendor
        });
    }

    openUpdatePrice(item, idx, e) {
        e.preventDefault();

        let {nb_click} = this.state;
        let {vendor} = this.props;
        this.setState({
            itemUpdate: item,
            nb_click: nb_click + 1,
            itemIdx: idx
        });
        let $ = window.$;
        $('#modal-update-price').modal('show');
    }

    renderItems() {
        let {allItems, itemVendor} = this.state;

        let content = allItems.map((it, idx) => {
            let origin_price = it.price
            let price = itemVendor[it._id] || it.price;
            let avarage_price = it.avarage || 0
            it.price = price;
            price = parseFloat(price).toFixed(2)
            let avarage = avarage_price ? (parseFloat(avarage_price) + parseFloat(origin_price)) / 2 : origin_price
            return (
                <tr key={idx}>
                    <td>{it.title}</td>
                    <td className="text-primary-kt fontSemiBold">{`$${convertPriceNumber(avarage)}`}</td>
                    <td className="text-primary-kt fontSemiBold">{`$${convertPrice(price)}`}</td>
                    <td className="text-center"><a href="#" className="action-update" onClick={this.openUpdatePrice.bind(this, it, idx)}>Update Price</a></td>
                </tr>
            );
        })

        return (
            <div className="form-group table-responsive table-kt">
                <table className="table">
                    <thead>
                        <tr>
                            <th>
                                Item 
                            </th>
                            <th>
                                Avarage    
                            </th>
                            <th>
                                Amount    
                            </th>
                            <th className="text-center" style={{width: "200px"}}>
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {content}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        let {itemUpdate, nb_click, page, number_page, isLoading} = this.state;
        return (
            <div className="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 maindb">
                <div className="form-group clearfix">
                    <div className="pull-left">
                        <h3 className="marginT0">Item</h3>
                    </div>
                </div>

                {(!isLoading) ? this.renderItems() : <div className="row text-center"><Spinner name="line-scale-pulse-out-rapid" color="steelblue"/></div>}
                
                <Pagination page={page} number_page={number_page} clickPage={this.clickPage.bind(this)} />

                <ModalUpdatePriceItems item={itemUpdate} vendor={this.props.vendor} nb_click={nb_click} updatePrice={this.updatePrice.bind(this)} nextItem={this.nextItem.bind(this)} />

            </div>
        );
    }
}

function mapStateToProps(state) {
    const {vendor} = state;
    return { 
        vendor
    }
}

export default connect(mapStateToProps)(ListItems);